import { render, staticRenderFns } from "./kpsrCause.vue?vue&type=template&id=5d7833c8"
import script from "./kpsrCause.vue?vue&type=script&lang=js"
export * from "./kpsrCause.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d7833c8')) {
      api.createRecord('5d7833c8', component.options)
    } else {
      api.reload('5d7833c8', component.options)
    }
    module.hot.accept("./kpsrCause.vue?vue&type=template&id=5d7833c8", function () {
      api.rerender('5d7833c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/kpsrCause.vue"
export default component.exports